import { Form, Input, Select, Button } from "antd";
import { ToastService } from "@shared/lib/services";

interface ReportFormProps {
  onSubmit: (values: { link: string }) => void;
  isSubmitting: boolean;
}

export function AddMediaForm({ onSubmit, isSubmitting }: ReportFormProps) {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    onSubmit({ ...values });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item
        name="link"
        label="Media Link"
        rules={[
          { required: true, message: "Report name is required" },
          { type: "url", message: "Please enter a valid URL!" },
        ]}
      >
        <Input placeholder="Media Link" />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          {isSubmitting ? "Adding..." : "Add"}
        </Button>
      </Form.Item>
    </Form>
  );
}
